import React from 'react';
import PropTypes from 'prop-types';
import { Box, Stack, Typography } from '@mui/material';
import {
  LEGEND_FOCUS_CANCELADOS,
  LEGEND_TIPO_KEYS,
  TIPO_COLOR,
  TIPO_LABEL,
  createDefaultLegendFilter,
} from './dateUtils';

/**
 * Legenda spotlight: default mostra todos; clique isola um tipo/cancelado;
 * re-clique no mesmo limpa o foco e volta a mostrar todos.
 */
const CalendarioTipoLegend = ({ value, onChange, sx }) => {
  const filter = value || createDefaultLegendFilter();
  const { focus } = filter;
  const isAll = focus == null;

  const setFocus = (key) => {
    onChange({
      focus: focus === key ? null : key,
    });
  };

  const itemSx = (active) => ({
    display: 'inline-flex',
    alignItems: 'center',
    gap: 0.75,
    m: 0,
    px: 1,
    py: 0.5,
    borderRadius: 1,
    border: '1px solid',
    borderColor: active ? 'divider' : 'transparent',
    bgcolor: active ? 'action.hover' : 'transparent',
    opacity: active ? 1 : 0.42,
    cursor: 'pointer',
    color: 'text.secondary',
    font: 'inherit',
    '&:hover': { bgcolor: 'action.selected' },
  });

  return (
    <Stack
      direction="row"
      spacing={1}
      flexWrap="wrap"
      useFlexGap
      sx={{ mt: 2, pt: 2, borderTop: '1px solid', borderColor: 'divider', ...sx }}
    >
      {LEGEND_TIPO_KEYS.map((tipo) => {
        const active = isAll || focus === tipo;
        return (
          <Box
            key={tipo}
            component="button"
            type="button"
            onClick={() => setFocus(tipo)}
            aria-pressed={!isAll && focus === tipo}
            sx={itemSx(active)}
          >
            <Box
              sx={{
                width: 10,
                height: 10,
                borderRadius: '50%',
                bgcolor: TIPO_COLOR[tipo].main,
                flexShrink: 0,
              }}
            />
            <Typography variant="caption" sx={{ fontWeight: active ? 600 : 400 }}>
              {TIPO_LABEL[tipo]}
            </Typography>
          </Box>
        );
      })}
      <Box
        component="button"
        type="button"
        onClick={() => setFocus(LEGEND_FOCUS_CANCELADOS)}
        aria-pressed={!isAll && focus === LEGEND_FOCUS_CANCELADOS}
        sx={itemSx(isAll || focus === LEGEND_FOCUS_CANCELADOS)}
      >
        <Box
          sx={{
            width: 10,
            height: 10,
            borderRadius: '50%',
            border: '1.5px dashed',
            borderColor: 'error.main',
            flexShrink: 0,
          }}
        />
        <Typography
          variant="caption"
          sx={{ fontWeight: isAll || focus === LEGEND_FOCUS_CANCELADOS ? 600 : 400 }}
        >
          Cancelado
        </Typography>
      </Box>
    </Stack>
  );
};

CalendarioTipoLegend.propTypes = {
  value: PropTypes.shape({
    focus: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
  sx: PropTypes.object,
};

CalendarioTipoLegend.defaultProps = {
  value: null,
  sx: null,
};

export default CalendarioTipoLegend;
